import { createRouter } from "@tanstack/react-router";

import { NotFoundPage, RouteErrorComponent } from "@/components/Pages/Status";
import { routeTree } from "@/routeTree.gen"; // این فایل auto-generated است

export const router = createRouter({
  routeTree,
  defaultErrorComponent: RouteErrorComponent,
  defaultNotFoundComponent: NotFoundPage,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
